import { Mode } from "types/Mode";

export const SUPPORTED_MODES: Mode[] = ["DRAYAGE", "FTL"];
